import { CardMedia, SxProps } from '@mui/material'
import { Component } from '../../types/ContentStructure'
import { FC } from 'react'

interface IComponentImageProps {
    component: Component
    sx?: SxProps
}
const ComponentImage: FC<IComponentImageProps> = ({ component, sx }) => {
    const { theme, title, image } = component;
    return <CardMedia
        component="img"
        sx={{ ...theme.themeStyles, ...sx }}
        image={image ?? undefined}
        alt={title}
        width="100%"
        height="100%"
    />
}

export default ComponentImage
